/* eslint-disable no-console,no-unused-vars */
import React from 'react';
import { Link } from 'gatsby';
import { TimelineMax } from 'gsap';
import BatteryFeaturedImage from '../../../../images/ace-features/battery.svg';
import CoilFeaturedImage from '../../../../images/ace-features/coil.svg';
import CapacityFeaturedImage from '../../../../images/ace-features/capacity.svg';
import MicroUSBFeaturedImage from '../../../../images/ace-features/micro-usb.svg';
import './style.scss';
import getCloudinary from '../../../../utils/getCloudinary';

const ACEDeliverySystem = () => {
    const [aceDeliverySystemImage, setAceDeliverySystemImage] = React.useState(null);
    const [featuredImage1Ref, setFeaturedImage1Ref] = React.useState(null);
    const [featuredImage2Ref, setFeaturedImage2Ref] = React.useState(null);
    const [featuredImage3Ref, setFeaturedImage3Ref] = React.useState(null);
    const [featuredImage4Ref, setFeaturedImage4Ref] = React.useState(null);

    React.useEffect(() => {
        if (aceDeliverySystemImage && featuredImage1Ref
            && featuredImage2Ref && featuredImage3Ref && featuredImage4Ref) {
            const tl = new TimelineMax();
            tl.to(featuredImage1Ref, 0.3, { ease: 'Power2.easeInOut', opacity: 1 }, '+=0.02');
            tl.to(featuredImage2Ref, 0.3, { ease: 'Power2.easeInOut', opacity: 1 }, '+=0.02');
            tl.to(featuredImage3Ref, 0.3, { ease: 'Power2.easeInOut', opacity: 1 }, '+=0.02');
            tl.to(featuredImage4Ref, 0.3, { ease: 'Power2.easeInOut', opacity: 1 }, '+=0.02');
        }
    });

    return (
        <div className="hero-swiper-slide ace-delivery-system-slide container">
            <div className="e-liquid-text">
                <div className="features columns is-hidden-touch is-multiline">
                    <img
                        className="column is-one-fifth-desktop is-half-touch"
                        src={BatteryFeaturedImage}
                        alt="350mah rechargable battery capacity"
                        ref={(featuredImage1) => {
                            setFeaturedImage1Ref(featuredImage1);
                        }}
                        style={{ opacity: 0 }}
                    />
                    <img
                        className="column is-one-fifth-desktop is-half-touch"
                        src={CoilFeaturedImage}
                        alt="1.6ohm nichrome coil"
                        ref={(featuredImage2) => {
                            setFeaturedImage2Ref(featuredImage2);
                        }}
                        style={{ opacity: 0 }}
                    />
                    <img
                        className="column is-one-fifth-desktop is-half-touch"
                        src={CapacityFeaturedImage}
                        alt="~2ml capacity"
                        ref={(featuredImage3) => {
                            setFeaturedImage3Ref(featuredImage3);
                        }}
                        style={{ opacity: 0 }}
                    />
                    <img
                        className="column is-one-fifth-desktop is-half-touch"
                        src={MicroUSBFeaturedImage}
                        alt="Mini USB Charger"
                        ref={(featuredImage4) => {
                            setFeaturedImage4Ref(featuredImage4);
                        }}
                        style={{ opacity: 0 }}
                    />
                </div>
                <div className="title is-size-4-touch is-size-3-desktop has-text-white e-liquid-text__title is-spaced">
                    DR WATSON Starter Pack + 1 free pod
                </div>
                <div className="subtitle is-size-4-touch is-size-3-desktop has-text-white e-liquid-text__description">
                £30 + VAT
                </div>
                <Link className="button is-large is-success" to="/cbd-delivery-system-feature">Shop Now</Link>
            </div>
            <img
                className="ace-delivery-system-image"
                src={getCloudinary().url(
                    'dashboard-uploads/three-devices-rotated_k6xrkb',
                    { height: 478, crop: 'fit', fetch_format: 'auto' },
                )}
                alt="CBD Delivery System"
                ref={(img) => {
                    setAceDeliverySystemImage(img);
                }}
            />
        </div>
    );
};

ACEDeliverySystem.propTypes = {

};

export default ACEDeliverySystem;
